export default {
  app: {
    orgCode: "Numero ng Grupo/Tatak",
    orgCodePlaceholder: "Mangyaring maglagay ng numero ng grupo/tatak",
    username: "Username",
    usernamePlaceholder: "Mangyaring ipasok ang Username",
    password: "Password",
    passwordPlaceholder: "pakilagay ang Password",
    captcha: "Verification Code",
    captchaPlaceholder: "pakilagay ang Verification Code",
    captchaExpired: "Mangyaring i-refresh ang verification code",
    login: "Mag log in",
    remember: "Tandaan ang impormasyon sa login",
    switchPC: "Lipat sa likod",
    mobileVersion: "Mobile BI",
    desktopVersion: "Backend ng Mangangalakal",
    setupPassword: "Itakda ang password",
    newPassword: "Bagong Password",
    newPasswordPlaceholder: "Mangyaring magpasok ng bagong password",
    retypePassword: "Ipasok muli ang bagong password",
    retypePasswordPlaceholder: "Pakipasok muli ang bagong password",
    setupPasswordRule: "Ang password ay dapat may 6-32 karakter at naglalaman ng hindi bababa sa dalawa sa mga sumusunod: numero, letra, simbolo.",
    setupPasswordRuleRefer: "Ang password ay kailangang 6-32 character at naglalaman ng higit sa dalawang kumbinasyon ng mga numero, titik, at simbolo. Pakipasok muli.",
    setupPasswordOk: "Oo naman",
    setupPasswordDiffer: "Ang mga password na ipinasok ng dalawang beses ay hindi pare-pareho, mangyaring muling ipasok.",
    err_def: "Nabigo ang pag-login, pakirefresh ang pahina at subukang muli.",
    err_2000: "maling verification code.",
    err_2010: "Maling impormasyon sa pag-login na ipinasok.",
    err_4001: "Ang account na ito ay hindi awtorisado para sa anumang mga function.",
    err_4011: "Ang tindahan ay na-disable, hindi makapag-login.",
    err_4012: "Ang franchisee ay na-disable, hindi makapag-login.",
    err_4013: "Ang brand ay na-disable, hindi makapag-login.",
    err_4014: "Ang grupo ay hindi pinagana, hindi makapag-login.",
    err_4015: "Ang región ay deaktibatin at hindi maaari ang login.",
    err_4401: "Ang account na ito ay hindi awtorisado para sa tindahang ito.",
    err_4402: "Ang account na ito ay walang admin rights at hindi makakuha ng verification code.",
    err_5001: "Ang pagtatakda ng password ay nabigo, subukan muli.",
  },
  verifyRefund: {
    title: "Kahilingan sa Pagbalik",
    hint: "Pakumpirma muna ang impormasyon bago magbigay ng verification code.",
    verifyCode: "Verification code",
    copy: "Kopyahin",
    copySucceed: "Matagumpay na Nakopya",
    copyFailed: "Nabigong kopyahin",
    expireTime: "Oras ng pag-expire",
    shop: "Tindahan",
    soTime: "Oras ng Order",
    soNo: "POS order number",
    amount: "Halaga ng refund",
  },
}